// extracted by mini-css-extract-plugin
export var forgotPasswordLink = "login-module--forgot-password-link--2OtbI";
export var forgotPassword__inner = "login-module--forgot-password__inner--1NVGH";
export var helpIcon = "login-module--help-icon--1htMg";